import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Utymc { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '編號 (MC001) 不可空白'}) 
    @MaxLength(15,{message: '編號 (MC001) 資料太長'})
    MC001: string = '';            // 編號 15 255.255.255.255 參考POSMY   UTYJI05

    @IsNotEmpty({message: '流水號 (MC002) 不可空白'}) 
    @MaxLength(6,{message: '流水號 (MC002) 資料太長'})
    MC002: string = '';            // 流水號 6 

    @MaxLength(15,{message: '外部IP (MC003) 資料太長'})
    MC003: string = '';            // 外部IP 15 

    @MaxLength(17,{message: 'MAC_Address (MC004) 資料太長'})
    MC004: string = '';            // MAC_Address 17 00:15:5d:00:75:06

    @MaxLength(255,{message: '備註 (MC005) 資料太長'})
    MC005: string = '';            // 備註 255 

    @MaxLength(2000,{message: '資料 (MC006) 資料太長'})
    MC006: string = '';            // 資料 2000 

    @MaxLength(50,{message: '帳號 (MC007) 資料太長'})
    MC007: string = '';            // 帳號 50 

    @MaxLength(50,{message: '密碼 (MC008) 資料太長'})
    MC008: string = '';            // 密碼 50 

    @MaxLength(15,{message: '內部IP (MC009) 資料太長'})
    MC009: string = '';            // 內部IP 15 255.255.255.255 參考POSMY

    @MaxLength(20,{message: '類別 (MC010) 資料太長'})
    MC010: string = '';            // 類別 20 A:

    @MaxLength(120,{message: '電腦名稱 (MC011) 資料太長'})
    MC011: string = '';            // 電腦名稱 120 

    @MaxLength(1,{message: 'alwaysOn (MC012) 資料太長'})
    MC012: string = 'N';            // alwaysOn 1 [DEF:"N"]

    @MaxLength(30,{message: 'VM主機 (MC013) 資料太長'})
    MC013: string = '';            // VM主機 30 


    MC014: Date | undefined;            // 偵測時間 0 

    @MaxLength(1,{message: 'isOnline (MC015) 資料太長'})
    MC015: string = 'N';            // isOnline 1 [DEF:"N"]

    @MaxLength(120,{message: 'shutdownAPI (MC016) 資料太長'})
    MC016: string = '';            // shutdownAPI 120 

    @MaxLength(120,{message: 'rebootAPI (MC017) 資料太長'})
    MC017: string = '';            // rebootAPI 120 

    @IsNumber() 
    MC018: number = 0;            // apiPort 6 

    @MaxLength(20,{message: 'platform (MC019) 資料太長'})
    MC019: string = 'win32';            // platform 20 [DEF:"win32"] 'android' 'aix', 'darwin', 'freebsd','linux', 'openbsd', 'sunos', and 'win32'

    @IsNotEmpty({message: 'customId (MC020) 不可空白'}) 
    @MaxLength(10,{message: 'customId (MC020) 資料太長'})
    MC020: string = '';            // customId 10 

    @MaxLength(20,{message: '上次開機時間 (MC021) 資料太長'})
    MC021: string = '';            // 上次開機時間 20 http://ip:port/LastBootupTime


}
